import { useMutation } from "react-query";
import { AreaComumForm } from "../typings";
import http from "infra/http";

function useAreaComum(tenantId: string | null) {
  return useMutation(
    (data: AreaComumForm) => {
      if (data.id) {
        return http.put(`/v1/tenants/${tenantId}/area-comum/${data.id}`, data);
      }

      return http.post(`/v1/tenants/${tenantId}/area-comum`, data);
    },
    { retry: false }
  );
}

export default useAreaComum;
